
namespace Areas.MyProjects.Projects {
    "use strict";

    export function goToAccount(e: any) {
        const grid = $("#ActiveProjectsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].accountId;
            let linkInfo = "/Account/Profile/View/" + id;
            window.open(linkInfo);
        }
    }

    export function goToProject(e: any) {
        const grid = $("#ActiveProjectsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].accountId;
            let linkInfo = "/Account/Profile/View/" + id;
            window.open(linkInfo);
        }
    }

    export function goToSharePoint(e: any) {
        const grid = $("#ActiveProjectsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var sharePointLink = row[0].sharePointLink;
            let linkInfo = "https://ucla.sharepoint.com/sites/CapitalPrograms/ActiveProjects/" + sharePointLink + "/";
            if (sharePointLink != "") {
                window.open(linkInfo);
            }
            else {
                window.open("https://ucla.sharepoint.com/sites/CapitalPrograms/ActiveProjectsList");
            }
        }
    }

    export function goToPIFPAF(e: any) {
        const grid = $("#ActiveProjectsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].projectInfoId;
            let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + id + "";
            if (id != null) {
                window.open(linkInfo);
            }
        }
    }

    export function goToContract(e: any) {
        const grid = $("#ActiveProjectsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].contractId;
            let linkInfo = "https://contract.capnet.ucla.edu/Contract/GeneralInfo/View/" + id + "";
            if (id != null) {
                window.open(linkInfo);
            }
        }
    }

    export function goToConstructionContract(e: any) {
        const grid = $("#ActiveProjectsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var accountId = row[0].accountId;

            if (accountId != null) {
                const url = `/Analysis/ActiveProjects/GetConstructionContract/${accountId}`;

                $.get(url, (contractId) => {
                    if (contractId > 0) {
                        let linkInfo = "https://contract.capnet.ucla.edu/Contract/GeneralInfo/View/" + contractId + "";
                        window.open(linkInfo);
                    } else {
                        DevExpress.ui.notify("There is no construction contract for this Project", "warning", 2000);
                    }
                });
            }


        }
    }

    export function contractViewLink(cellElement: any, cellInfo: any) {
        let linkInfo = "<a href= 'https://contract.capnet.ucla.edu/Contract/GeneralInfo/View/{placeholder}' target=\"_blank\">View</a>";

        buildCellContent(cellElement,
            () => { return cellInfo.data.contractId; },
            linkInfo);
    }

    export function projectViewLink(cellElement: any, cellInfo: any) {
        let linkInfo = "<a href= '/Account/Profile/View/{placeholder}' target=\"_blank\">View</a>";

        buildCellContent(cellElement,
            () => { return cellInfo.data.accountId; },
            linkInfo);
    }
}
